import { cloneElement } from 'react';
import { usePagination } from '@chaser/components';

export default function useSteps(stepElements, opts = {}) {
  const {
    page,
    pageData,
    canPreviousPage,
    canNextPage,
    gotoPage,
    previousPage,
    nextPage,
  } = usePagination({
    data: stepElements,
    pageSize: 1,
    initialPage: opts.initialStep,
    page: opts.step,
    onPageChange: opts.onStepChange,
  });

  const meta = {
    step: page,
    steps: stepElements.length,
    gotoStep: gotoPage,
    hasPreviousStep: canPreviousPage,
    hasNextStep: canNextPage,
    previousStep: previousPage,
    nextStep: nextPage,
  };

  const stepElement =
    typeof pageData[0] === 'function'
      ? pageData[0](meta)
      : cloneElement(pageData[0], { stepProps: meta });

  return [stepElement, meta];
}
